// src/pages/ActivitiesPage.js
import React from "react";
import RamMandir from "../assets/Ayurved.jpg";

const ActivitiesPage = () => {
  return (
    <section id="activities" className="wrap">
      <h2>Activities & Events</h2>
      <p>Select highlights from current initiatives, awareness programs & cultural events.</p>

      <div className="carousel">
        <div className="carousel-viewport">
          <div className="carousel-track" aria-hidden="false" role="list">
            <article className="card" role="listitem">
              <img src={RamMandir} alt="Community event" />
              <div className="card-body">
                <div className="meta">12 Aug 2025</div>
                <div className="card-title">Community Health Camp — Sadguru Hospital Outreach</div>
                <div style={{ marginTop: "auto" }}>
                  <a href="#" style={{ color: "var(--primary)", fontWeight: "700" }}>
                    Read More →
                  </a>
                </div>
              </div>
            </article>
            {/* Add more cards similarly */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesPage;
